/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>导购知识</el-breadcrumb-item>
      <el-breadcrumb-item>导购知识视频新增</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        
        
		<el-form label-width="120px" ref="editForm" :model="formProInfo" class="editForm">
		  <el-form-item label="视频名称" prop="productName">
		    <el-input size="small" v-model="formProInfo.name" auto-complete="off" placeholder="请输入分类名称"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="所属分类1">
		   <el-select size="small" v-model="formProInfo.firstLevelId" placeholder="请选择"  @change="changetype">
		      <el-option v-for="(item,index) in typeList1" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="所属分类2">
		   <el-select size="small" v-model="formProInfo.secondLevelId" placeholder="请选择" @change="changetype1">
		       <el-option v-for="(item,index) in typeList2" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="所属分类3">
		   <el-select size="small" v-model="formProInfo.thirdLevelId" placeholder="请选择">
		       <el-option v-for="(item,index) in typeList3" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="序号" prop="sortNumber">
		    <el-input size="small" v-model="formProInfo.sortNumber" auto-complete="off" placeholder="请输入序号,数字越小越靠前，整数"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="是否允许下载" :prop="formProInfo.downloadStatus">
		    <el-radio v-model="formProInfo.downloadStatus" label="1">是</el-radio>
		    <el-radio v-model="formProInfo.downloadStatus" label="0">否</el-radio>
		  </el-form-item>
		  
		  <el-form-item label="是否允许分享" :prop="formProInfo.shareStatus">
		    <el-radio v-model="formProInfo.shareStatus" label="1">是</el-radio>
		    <el-radio v-model="formProInfo.shareStatus" label="0">否</el-radio>
		  </el-form-item>
		  
		  <el-form-item label="状态" :prop="formProInfo.active">
		    <el-radio v-model="formProInfo.active" label="1">启用</el-radio>
		    <el-radio v-model="formProInfo.active" label="0">禁用</el-radio>
		  </el-form-item>
		  
		 <!-- <el-form-item label="视频类型" :prop="formProInfo.videoType">
		    <el-radio v-model="formProInfo.videoType" label="0">视频文件</el-radio>
		    <el-radio v-model="formProInfo.videoType" label="1">视频链接</el-radio>
		  </el-form-item> -->
		 
		 <el-form-item   label="视频文件">
		   <el-upload
		     class="upload-demo"
		     :action="uploadUrl()"
		     :http-request="customUpload"
		     :on-preview="handlePreview"
		     :on-remove="handleRemove"
		     :file-list="resultFilelist2"
		     :limit='1'
		     accept=".mp4,.avi,.mpeg"
		     list-type="picture-card">
		     <el-button size="small" type="primary">点击上传视频</el-button>
		     <div slot="tip" class="el-upload__tip">只能上传mp4、avi、mpeg 视频，最多可上传1个视频</div>
		     <div slot="file" slot-scope="{file}">
				 <el-progress type="circle" :percentage="progressPercent" v-if="isUpload"></el-progress>
		       <video
		         class="el-upload-list__item-thumbnail"
		         :src="file.url" alt=""
		         :autoplay="true"
		       ></video>
		       <span class="el-upload-list__item-actions">
		         <!-- <span
		           class="el-upload-list__item-preview"
		           @click="handlePreview(file)"
		         >
		           <i class="el-icon-zoom-in"></i>
		         </span> -->
		         
		         <span
		           class="el-upload-list__item-delete"
		           @click="handleRemove(file)"
		         >
		           <i class="el-icon-delete"></i>
		         </span>
		       </span>
		     </div>
		   </el-upload>
		   
		 </el-form-item>
		 <!-- <el-form-item   label="视频链接" v-if="formProInfo.videoType==1">
			   <el-input size="small" v-model="formProInfo.videoUrl" auto-complete="off" placeholder="请输入视频链接"></el-input>
			 
		 </el-form-item> -->
		  
		  <el-form-item   label="视频封面">
		    
		    <el-upload
		      class="upload-demo"
		      :action="uploadUrl()"
		      :http-request="customUpload1"
		      :on-preview="handlePreview1"
		      :on-remove="handleRemove1"
		      :file-list="resultFilelist1"
		      :limit='1'
		      accept=".png,.jpg,.jpeg"
		      list-type="picture-card">
			 
			   <div slot="file" slot-scope="{file}">
				    <el-progress type="circle" :percentage="progressPercent1" v-if="isUpload1"></el-progress>
			        <img
			          class="el-upload-list__item-thumbnail"
			          :src="file.url" alt=""
			        >
			        <span class="el-upload-list__item-actions">
			         <!-- <span
			            class="el-upload-list__item-preview"
			            @click="handlePictureCardPreview(file)"
			          >
			            <i class="el-icon-zoom-in"></i>
			          </span> -->
			          
			          <span
			            class="el-upload-list__item-delete"
			            @click="handleRemove1(file)"
			          >
			            <i class="el-icon-delete"></i>
			          </span>
			        </span>
			    </div>
		      <el-button size="small" type="primary">点击上传图片</el-button>
		      <div slot="tip" class="el-upload__tip">上传1张图片作为视频封面，建议尺寸114x100px</div>
			  
		    </el-upload>
		   
		  </el-form-item>
		  
		  
		</el-form>
		
		
		<div slot="footer" class="dialog-footer">
		  <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">保存</el-button>
		</div>
		
		
		
		
		
		
      </div>
    </template>

    <script>
    // 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      createShoppyFile,
	  getShoppyFileById,
	  updateShoppyFile,
	  getShoppyTypeList,
	  getShoppyTypeById,
	  updateShoppyType
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
		  keytype:0,
		  uploadTimer: null,//调取进度条的轮询定时器
		  isUpload: false,//文件是否上传中
		  progressPercent: 0,//进度条当前进度
		  isUpload1: false,//文件是否上传中
		  progressPercent1: 0,//进度条当前进度
          title: '导购分类新增',
		  typeList1:'',
		  typeList2:'',
		  typeList3:'',
          // 请求数据参数
          formProInfo: {
            // 分类名称(支持右模糊查询)
            name: '',
            //所属导购：1-导购知识视频；2-服务视频；3-导购文件
            category:1,
            updator:'',
			firstLevelId:'',
			secondLevelId:'',
			thirdLevelId:'',
			downloadStatus:'0',
			shareStatus:'0',
			active:'1',
			sortNumber:''
			// videoType:'0',
			// videoUrl:''
          },
    	  id:'',
		  shuo:'',
         resultFilelist2:[],
		 resultFilelist1:[]
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.shuo = this.$route.query.shuo
		 this.changedao()
		  if(this.shuo=='新增'){
			  this.title = '知识导购视频新增'
		  }else{
			  this.title = '知识导购视频编辑'
			  this.handleEdit()
		  }
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getShoppyFileById(this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         let data = res.data
		         this.formProInfo.name = data.name
		         this.formProInfo.active= data.active.toString()
		         this.formProInfo.updator= data.updator
				 this.formProInfo.sortNumber = data.sortNumber
				 // this.formProInfo.videoType= data.videoType.toString()
				 // this.formProInfo.videoUrl= data.videoUrl
		         this.formProInfo.firstLevelId= data.firstLevelId.toString()
				 this.changetype()
		         this.formProInfo.secondLevelId= data.secondLevelId.toString()
				 this.changetype1()
		         this.formProInfo.thirdLevelId= data.thirdLevelId
		         this.formProInfo.downloadStatus= data.downloadStatus.toString()
		         this.formProInfo.shareStatus= data.shareStatus.toString()
				 
				 this.resultFilelist1 = []
				 this.resultFilelist2 = []
				 if(data.fileCoverInfo){
					this.resultFilelist1.push({
					  url:data.fileCoverInfo.fileTemporaryUrl,
					  fileTemporaryUrl:data.fileCoverInfo.fileTemporaryUrl,
					  fileId:data.fileCoverInfo.fileId,
					  name: data.fileCoverInfo.ossFile.fileName,
					}) 
				 }
				 
				 if(data.fileInfo){
					this.resultFilelist2.push({
					  url:data.fileInfo.fileTemporaryUrl,
					  fileTemporaryUrl:data.fileInfo.fileTemporaryUrl,
					  fileId:data.fileInfo.fileId,
					  name: data.fileInfo.ossFile.fileName,
					}) 
				 }
				
				   
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		  uploadUrl(){
		    return '/mtl/marking/api/main/oss-file/upload-file'
		  },
		  handlePreview(file){
		    console.log(file)
		   
		  },
		  handlePreview1(file){
		    console.log(file)
		   
		  },
		  customUpload(req){
		    let _this = this
		    console.log(req)
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
			this.isUpload = true
		    this.progressPercent = 45
		      uploadFile(this.uploadUrl(), formData).then(response => {
				 
		        if(response.data.success){
				 this.progressPercent = 100
				 setTimeout(()=>{
				 	this.isUpload = false
				 },1500)
		          let data = response.data.data
		          console.log(data)
		          _this.resultFilelist2.push({
		                  url:data.fileTemporaryUrl,
		                  fileTemporaryUrl:data.fileTemporaryUrl,
		                  fileId:data.fileId,
		                  name: data.ossFile.fileName,
		                  uid: req.file.uid,
		                  mediaObjInfo:data
		              })
		            
		          
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(99999999,_this.resultFilelist2)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		  customUpload1(req){
		    let _this = this
		    console.log(req)
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
			this.isUpload1 = true
		     this.progressPercent1 = 45
		      uploadFile(this.uploadUrl(), formData).then(response => {
		  				 
		        if(response.data.success){
					this.progressPercent1 = 100
					setTimeout(()=>{
						this.isUpload1 = false
					},1500)
		          let data = response.data.data
		          console.log(data)
		          _this.resultFilelist1.push({
		                  url:data.fileTemporaryUrl,
		                  fileTemporaryUrl:data.fileTemporaryUrl,
		                  fileId:data.fileId,
		                  name: data.ossFile.fileName,
		                  uid: req.file.uid,
		                  mediaObjInfo:data
		              })
		            
		          
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(99999999,_this.resultFilelist1)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		  handleRemove(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index2 = this.resultFilelist2.findIndex(item => item.fileId === file.fileId)
		     console.log(index2)
		     this.resultFilelist2.splice(index2,1);
		  },
		  handleRemove1(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index2 = this.resultFilelist1.findIndex(item => item.fileId === file.fileId)
		     console.log(index2)
		     this.resultFilelist1.splice(index2,1);
		  },
		//编辑
		goback() {
			this.$router.push({ path: '/product2'})
		 
		},
		changelevel(e){
			if(this.shuo=='新增'){
				this.level = e
				 this.title = '知识导购分类' + this.level +'新增'
			}else{
				this.title = '知识导购分类' + this.level +'编辑'
			}
		},
      changedao(e){
		  console.log(12345,e)
		 // this.formProInfo.category = e
		 let parm = {
			 level:1,
			 category:1,
			 firstLevelId:'',
			 secondLevelId:''
			 
		 }
		  getShoppyTypeList(parm).then(res => {
		    console.log(123)
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
			
		    this.typeList1 = res.data
			
		    }
		  })
	  },
	  changetype(e){
		  console.log(123456,e)
		  //this.formProInfo.firstLevelId = e
		  let parm = {
				 level:2,
				 category:1,
				 firstLevelId:this.formProInfo.firstLevelId,
				 secondLevelId:''
		  			 
		  }
		  getShoppyTypeList(parm).then(res => {
			console.log(123)
			this.loading = false
			if (res.success == false) {
			  this.$message({
				type: 'info',
				message: res.msg
			  })
			} else {
					if(this.shuo=='新增'){
						this.formProInfo.secondLevelId = null
						this.formProInfo.thirdLevelId = null
						this.typeList2 = res.data
					}else{
						this.typeList2 = res.data
					}
				
			
			
			}
		  })
	  },
	  changetype1(e){
	  		  console.log(123456,e)
	  		  //this.formProInfo.firstLevelId = e
	  		  let parm = {
	  				 level:3,
	  				 category:1,
	  				 firstLevelId:this.formProInfo.firstLevelId,
	  				 secondLevelId:this.formProInfo.secondLevelId
	  		  			 
	  		  }
	  		  getShoppyTypeList(parm).then(res => {
	  			console.log(123)
	  			this.loading = false
	  			if (res.success == false) {
	  			  this.$message({
	  				type: 'info',
	  				message: res.msg
	  			  })
	  			} else {
				if(this.shuo=='新增'){
					this.formProInfo.thirdLevelId = null
					this.typeList3 = res.data
				}else{
					this.typeList3 = res.data
				}
				
	  			
	  			}
	  		  })
	  },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


        
        
        // 编辑、添加提交方法
        saveProInfo(){
            console.log(this.content)
             if(!this.formProInfo.name){
              return this.$message({
                      type: 'warning',
                      message: '请填写分类名称'
                    })
            }
			
			if(!this.formProInfo.firstLevelId){
			  return this.$message({
			          type: 'warning',
			          message: '请选择分类1！'
			        })
			}
			if(!this.formProInfo.secondLevelId){
			  return this.$message({
			          type: 'warning',
			          message: '请选择分类2！'
			        })
			}
			if(this.resultFilelist2.length==0){
				return this.$message({
				        type: 'warning',
				        message: '请上传视频！'
				      })
			}
			if(this.resultFilelist1.length==0){
				return this.$message({
				        type: 'warning',
				        message: '请上传封面！'
				      })
			}
			this.formProInfo.sortNumber = Number(this.formProInfo.sortNumber)
			let sortNumbertype = Number.isInteger(this.formProInfo.sortNumber)
			if(sortNumbertype==false){
			  return this.$message({
			          type: 'warning',
			          message: '请填写整数！'
			        })
			}
			if(this.resultFilelist2.length>0){
				this.formProInfo.fileInfo = this.resultFilelist2[0].mediaObjInfo
			}
			if(this.resultFilelist1.length>0){
				this.formProInfo.fileCoverInfo = this.resultFilelist1[0].mediaObjInfo
			}
			if(this.formProInfo.sortNumber==''){
				this.formProInfo.sortNumber=null
			}
			
            if(this.shuo=='新增'){
				createShoppyFile(this.formProInfo).then(res => {
				  console.log(123)
				  this.loading = false
				  if (res.success == false) {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				   this.$router.push({ path: '/product2'})
				  }
				})
			}else{
				this.formProInfo.id = this.id
				updateShoppyFile(this.formProInfo).then(res => {
				  console.log(123)
				  this.loading = false
				  if (res.success == false) {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				   this.$router.push({ path: '/product2'})
				  }
				})
			}
          
    		
        },

       

        // 选择复选框事件
        selectChange(val) {
          this.selectdata = val
        },
       
        

      }
    }
    </script>

    <style scoped>
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
    </style>





// WEBPACK FOOTER //
// src/views/knowledge/productadd2.vue